import React, { useEffect } from "react";
import { App, Card, Typography } from "antd";
import { Formik, Form } from "formik";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { useParams, useNavigate } from "react-router-dom";
import AppControl from "../../../components";
import { createYupSchema } from "../../../utilities";
import { fetchScreens } from "../../../store/slice/common";
import { getRole, saveRole, updateRole } from "../../../store/slice/roles";

const { Title } = Typography;

function RoleAddEdit() {
  const { id } = useParams();
  const { message } = App.useApp();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pages, screens } = useSelector((state) => state.common);
  const { role, isLoading } = useSelector((state) => state.roles);

  const title = id ? "Edit Role" : "Create a New Role";

  useEffect(() => {
    dispatch(fetchScreens());
    if (id) dispatch(getRole(id));
  }, [id, dispatch]);

  const controls =
    pages?.find((p) => p.formName === "Role")?.fields ?? [];

  const initialValues = controls.reduce((acc, control) => {
    acc[control.fieldId] =
      id && role ? role[control.fieldId] : control.defaultValue;
    return acc;
  }, {});

  const validationSchema = Yup.object().shape(
    controls.reduce(createYupSchema, {}),
  );

  const onSubmit = async (values) => {
    const thunkCreator = id ? updateRole : saveRole;
    const payload = id ? { ...values, id: role.id } : values;
    const resultAction = await dispatch(thunkCreator(payload));

    if (thunkCreator.fulfilled.match(resultAction)) {
      message.success(resultAction.payload.message);
      navigate("/roles");
    } else {
      message.error(`Save failed: ${resultAction.error.message}`);
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {(formik) => (
        <Card title={<Title level={5}>{title}</Title>}>
          <Form>
            <div className="md:columns-1 mb-3">
              {screens &&
                controls.map((control) => (
                  <AppControl
                    key={control.fieldId}
                    control={control.type}
                    label={control.label}
                    name={control.fieldId}
                    placeholder={control.placeholder}
                    options={screens}
                  />
                ))}
            </div>
            <AppControl
              control="button"
              type="submit"
              name="Save"
              size="md"
              color="orange"
              disabled={!formik.isValid || isLoading}
              loading={isLoading}
            />
            <AppControl
              control="button"
              type="button"
              name="Cancel"
              size="md"
              color="blue"
              onClick={() => navigate("/roles")}
            />
          </Form>
        </Card>
      )}
    </Formik>
  );
}

export default RoleAddEdit;
